/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type UpdateMyProfileMutationVariables = Types.Exact<{
  name: Types.Scalars["String"];
  legal_name: Types.Scalars["String"];
}>;

export type UpdateMyProfileMutation = {
  updateMyProfile: Pick<
    Types.User,
    "id" | "name" | "legal_name" | "email" | "email_verified_at"
  >;
};

export const UpdateMyProfileDocument = gql`
  mutation UpdateMyProfile($name: String!, $legal_name: String!) {
    updateMyProfile(name: $name, legal_name: $legal_name) {
      id
      name
      legal_name
      email
      email_verified_at
    }
  }
`;

/**
 * __useUpdateMyProfileMutation__
 *
 * To run a mutation, you first call `useUpdateMyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyProfileMutation, { data, loading, error }] = useUpdateMyProfileMutation({
 *   variables: {
 *      name: // value for 'name'
 *      legal_name: // value for 'legal_name'
 *   },
 * });
 */
export function useUpdateMyProfileMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateMyProfileMutation,
    UpdateMyProfileMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpdateMyProfileMutation,
    UpdateMyProfileMutationVariables
  >(UpdateMyProfileDocument, baseOptions);
}
export type UpdateMyProfileMutationHookResult = ReturnType<
  typeof useUpdateMyProfileMutation
>;
export type UpdateMyProfileMutationResult =
  ApolloReactCommon.MutationResult<UpdateMyProfileMutation>;
export type UpdateMyProfileMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateMyProfileMutation,
    UpdateMyProfileMutationVariables
  >;
